import React from "react";
import ScrollToTopOnMount from "../ScrollToTopOnMount";
import ImgHeader from "../ImgHeader";
import WithHelperBar from "../WithHelperBar";
import { H1 } from "../Headers";
import fromMarkdown from "../../functions/fromMarkdown";

export default function APIDefinition() {
  return (
    <>
      <ScrollToTopOnMount />
      <ImgHeader url="/static/img/Documentation.png" shadowOpacity={0.5}>
        <H1>What is an API?</H1>
      </ImgHeader>
      <WithHelperBar>{fromMarkdown("content/apidefinition.md")}</WithHelperBar>
    </>
  );
}
